import config from 'config'

const authApi = `${config.apiHost}/oem-auth`

export default {
    currentTree: {
        url: `${authApi}/api/departments/tree/current`,
        type: 'GET',
    },
    departments: {
        url: `${authApi}/api/departments`,
        type: 'GET',
    },
}
